package app.alefly.domain.model

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class QuestionOption(
    val id: String,
    val text: String? = null,
    val isCorrect: Boolean,
    val imageUrl: String? = null,
)

@Serializable
data class Hint(
    val text: String,
)

@Serializable
data class Explanation(
    val text: String,
)

@Serializable
data class Question(
    val id: QuestionId,
    val quizId: QuizId,
    val locale: String,
    val status: TenantStatus,
    val difficulty: Difficulty,
    val text: String,
    val imagePrompt: String? = null,
    val options: List<QuestionOption>,
    val hint: Hint? = null,
    val explanation: Explanation? = null,
    val randInt: Int,
    val bucket: Int,
    val tags: List<String> = emptyList(),
    val createdAt: Instant? = null,
    val updatedAt: Instant? = null,
)
